"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3_scale_1 = require("d3-scale");
var utils_1 = require("../utils");
var defaultColors = [
    "#edf8e9",
    "#c7e9c0",
    "#a1d99b",
    "#74c476",
    "#41ab5d",
    "#238b45",
    "#005a32"
];
var HeatmapDataStore = (function () {
    function HeatmapDataStore(args) {
        this.M = args.M;
        this.T = args.T;
        this.W = args.W;
        this.Th = args.Th;
        this.F = args.F;
        this.Sa = args.Sa;
        this.Su = args.Su;
        this.days = [this.M, this.T, this.W, this.Th, this.F, this.Sa, this.Su];
        this.colors = args.colors ? args.colors : defaultColors;
        this.domain = args.domain ? args.domain : this.calcDomain();
        this.scale = this.createScale();
    }
    ;
    HeatmapDataStore.prototype.calcDomain = function () {
        var uniqueValues = [];
        this.days.forEach(function (day) {
            day.hours.forEach(function (hour) {
                if (!(uniqueValues.indexOf(hour.value) > -1)) {
                    uniqueValues.push(hour.value);
                }
            });
        });
        return uniqueValues;
    };
    ;
    HeatmapDataStore.prototype.createScale = function () {
        var domain = this.calcDomain();
        var colorScale = d3_scale_1.scaleQuantile()
            .domain(domain)
            .range(this.colors);
        return colorScale;
    };
    ;
    HeatmapDataStore.fromRows = function (_a) {
        var rows = _a.rows, dateColumn = _a.dateColumn, valueColumn = _a.valueColumn;
        var _b = utils_1.generateDays(), M = _b.M, T = _b.T, W = _b.W, Th = _b.Th, F = _b.F, Sa = _b.Sa, Su = _b.Su;
        var dayMap = { 0: Su, 1: M, 2: T, 3: W, 4: Th, 5: F, 6: Sa };
        rows.forEach(function (r) {
            var date = !utils_1.isDate(r[dateColumn]) ? utils_1.readDate(r[dateColumn], true) : r[dateColumn];
            var dayInt = date.getDay();
            var hourInt = date.getHours();
            var minuteInt = date.getMinutes();
            console.log(utils_1.getTimeString(date));
            var day = dayMap[dayInt];
            var hour = day.hours[hourInt];
            var minute = hour.minutes[minuteInt];
            var value;
            if (valueColumn) {
                value = r[valueColumn];
            }
            else {
                value = 1;
            }
            hour.value = hour.value + value;
            minute.data = r;
        });
        return new HeatmapDataStore({ M: M, T: T, W: W, Th: Th, F: F, Sa: Sa, Su: Su });
    };
    return HeatmapDataStore;
}());
exports.default = HeatmapDataStore;
